import { Box } from "@chakra-ui/react";
import AuthCaption from "../components/AuthCaption";
import InfoGropup from "../components/InfoGroup";

type IProps = {
  form: JSX.Element;
  error?: JSX.Element | null;
  caption?: string;
};

const Right = ({ form, error, caption }: IProps) => {
  return (
    <Box>
      <Box
        sx={{
          mt: { base: "0rem", md: "1rem", lg: "0rem" },
          mb: { base: error ? 4 : 0, md: "2rem" },
        }}
      >
        {error ? <Box>{error}</Box> : caption ?? <AuthCaption />}
      </Box>

      <InfoGropup
        sx={{
          flexDirection: "column-reverse",
          display: { base: "none", md: "flex" },
        }}
      />
      {form}
      <InfoGropup
        sx={{
          flexDirection: "column",
          display: { base: "flex", md: "none" },
        }}
      />
    </Box>
  );
};

export default Right;
